module.exports = __webpack_public_path__ + "img/scientist11.1de859b5.jpg";